import React, { useEffect, useState } from 'react'
import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Alert, Autocomplete } from '@mui/material';
import { searchDrugService } from '../../../services';
import { Translate, withLocalize } from 'react-localize-redux';

import { ButtonAccept, ButtonCancel, ButtonOk } from '../mini_components';
import DrugSelector from './DrugSelector';
import {addMinutes} from 'date-fns'
import { getDateFromStringOrDate } from '../../../utils/bill';
import { getCurrentResearcherUuid } from '../../../utils';
import { isHourBasedFrequency } from '../../../utils/frequencyConfig';

const DAYS = "days";
const WEEKS = "weeks";
const MONTHS = "months";
// interface Props{
//     name : string,
//     label : string,
//     typeMargin : string,
//        errorState: boolean,
//     drugSelected: (drugSel:string) => void
// }

function SingleTreatmentSelector(props){

    const [isCurrent, setIsCurrent] = useState(false);
    const [frecuency, setfrecuency] = useState(null);
    const [startTime, setStartTime] = useState("06");
    const [dose, setDose] = useState(null);
    const [dose_amount, setDoseAmount] = useState(null);
    const [dose_unit, setDoseUnit] = useState(null);
    const [errorfrecuency, setErrorfrecuency] = useState(false);
    const [isOneDose, setIsOneDose] = useState(false);
    const [errorDose, setErrorDose] = useState(false);
    const [errorDoseAmount, setErrorDoseAmount] = useState(false);
    const [errorDoseUnit, setErrorDoseUnit] = useState(false);

    const [amount, setAmount] = useState(null);
    const [timeUnit, setTimeUnit] = useState(null);
    const [errorDuration, setErrorDuration] = useState(false);
    const [errorDrug, setErrorDrug] = useState(false);
    const [drug, setDrug] = useState(null);
    const [route, setRoute] = useState(null);
    const [errorRoute, setErrorRoute] = useState(false);
    const [errorStopMotive, setErrorStopMotive] = useState(false);

    // Date pickers for inpatient treatments
    const [inpatientStartDate, setInpatientStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [inpatientEndDate, setInpatientEndDate] = useState("");
    const [errorEndDate, setErrorEndDate] = useState(false);
    
    const [error, setError] = useState(false);
    
    // Initialize form fields from editingElement when editing
    useEffect(() => {
        if (props.editingElement && props.type === "treatment_inpatient") {
            const element = props.editingElement;
            
            // Set drug - create drug object from stored data
            // Handle both cases: with drug-code and without (old format)
            if (element.treatment_inpatient) {
                const drugObj = {
                    id: element["drug-code"] || "offline", // Use "offline" if no drug-code
                    name: element.treatment_inpatient
                };
                setDrug(drugObj);
            }
            
            // Set route
            if (element["treatment-route"]) {
                setRoute(element["treatment-route"]);
            }
            
            // Set frequency
            if (element["treatment-frecuency"]) {
                setfrecuency(element["treatment-frecuency"]);
                // Check if it's single dose
                if (element["treatment-frecuency"] === "single-dose") {
                    setIsOneDose(true);
                } else {
                    setIsOneDose(false);
                }
            }

            // Set start time
            if (element["treatment-startTime"]) {
                setStartTime(element["treatment-startTime"]);
            }
            
            // Set dose amount and unit - handle backward compatibility
            if (element["treatment-dose"] !== undefined && element["treatment-dose"] !== null) {
                // New format: treatment-dose
                setDoseAmount(element["treatment-dose"].toString());
            } else if (element["treatment-dose_amount"]) {
                // Old format: treatment-dose_amount (for backward compatibility)
                const oldDose = element["treatment-dose_amount"].toString().trim();
                setDoseAmount(oldDose);
            }
            
            if (element["treatment-unit"]) {
                setDoseUnit(element["treatment-unit"]);
            } else if (element["treatment-dose_unit"]) {
                // Old format: for backward compatibility
                setDoseUnit(element["treatment-dose_unit"]);
            }
            
            // Set start date (preserve original)
            // Note: start date shouldn't change when editing
            
            // Determine if current or one dose based on finish date
            // Set start date
            if (element["treatment-start"]) {
                const sd = getDateFromStringOrDate(element["treatment-start"]);
                setInpatientStartDate(sd.toISOString().split('T')[0]);
            }

            if (element["treatment-finish"]) {
                const finishDate = getDateFromStringOrDate(element["treatment-finish"]);
                const startDate = element["treatment-start"] ? getDateFromStringOrDate(element["treatment-start"]) : new Date();

                // Check if it's a single dose (finish date equals start date)
                if (finishDate.getTime() === startDate.getTime()) {
                    setIsOneDose(true);
                    setIsCurrent(false);
                    setInpatientEndDate("");
                }
                // Check if it's chronic (finish date is null, undefined, or very far in the future)
                else if (!finishDate || isNaN(finishDate.getTime()) || finishDate > new Date('2099-12-31')) {
                    setIsCurrent(true);
                    setIsOneDose(false);
                    setInpatientEndDate("");
                }
                // Has a specific finish date
                else {
                    setIsCurrent(false);
                    setIsOneDose(false);
                    setInpatientEndDate(finishDate.toISOString().split('T')[0]);
                }
            } else {
                // No finish date means chronic
                setIsCurrent(true);
                setIsOneDose(false);
                setInpatientEndDate("");
            }
        } else if (!props.editingElement) {
            // Reset form when not editing
            setDrug(null);
            setRoute(null);
            setfrecuency(null);
            setDoseAmount(null);
            setDoseUnit(null);
            setIsCurrent(false);
            setIsOneDose(false);
            setAmount(null);
            setTimeUnit(null);
            setInpatientStartDate(new Date().toISOString().split('T')[0]);
            setInpatientEndDate("");
        }
    }, [props.editingElement, props.type]);
    
    function saveDrug(){
        let valid = true;
        if(!drug){
            setErrorDrug(true);
            valid = false;
        }
        if(!frecuency){
            setErrorfrecuency(true);
            valid = false;
        }
        if(props.type === "treatment_inpatient"){
            if (!dose_amount || dose_amount.toString().trim() === "") {
                setErrorDoseAmount(true);
                valid = false;
            } else {
                const doseAmountStr = dose_amount.toString().trim();
                let numericValue;
                
                // Check if it's a fraction
                if (doseAmountStr.includes('/')) {
                    const parts = doseAmountStr.split('/');
                    if (parts.length !== 2) {
                        setErrorDoseAmount(true);
                        valid = false;
                    } else {
                        const [numerator, denominator] = parts.map(s => s.trim());
                        const num = parseFloat(numerator);
                        const den = parseFloat(denominator);
                        
                        if (isNaN(num) || isNaN(den) || den === 0) {
                            setErrorDoseAmount(true);
                            valid = false;
                        } else {
                            numericValue = num / den;
                            if (numericValue < 0) {
                                setErrorDoseAmount(true);
                                valid = false;
                            }
                        }
                    }
                } else {
                    // Handle integer or decimal (normalize comma to period)
                    const normalizedDoseAmount = doseAmountStr.replace(',', '.');
                    numericValue = parseFloat(normalizedDoseAmount);
                    
                    if (isNaN(numericValue) || numericValue < 0 || !/^\d+([.,]\d+)?$/.test(doseAmountStr)) {
                        setErrorDoseAmount(true);
                        valid = false;
                    }
                    // Check for "0" without decimals
                    if (numericValue === 0 && !normalizedDoseAmount.includes('.')) {
                        setErrorDoseAmount(true);
                        valid = false;
                    }
                }
            }
            if (!dose_unit) {
                setErrorDoseUnit(true);
                valid = false;
            }
        } else {
            if(!dose){
                setErrorDose(true);
                valid = false;
            }
        }
        if(props.type === "treatment_inpatient" && !route){
            setErrorRoute(true);
            valid = false;
        }
        if(valid && props.type === "treatment_regular"){
            props.elementSelected({
                treatment_regular:drug.name,"drug-code" : drug.id, 
                "treatment_regular-frecuency": frecuency, 
                "treatment_regular-dose": dose
            });
            return;
        }

        if(props.type === "treatment_inpatient" && !isCurrent && !isOneDose && !inpatientEndDate){
            setErrorEndDate(true);
            valid = false;
        }
        if(props.type === "treatment_inpatient" && !isCurrent && !isOneDose && inpatientEndDate && inpatientEndDate < inpatientStartDate){
            setErrorEndDate(true);
            valid = false;
        }

        if(valid && props.type === "treatment_inpatient" ){
            // startDate (a Date) is only used to derive the one-dose finish instant below.
            const startDate = new Date(inpatientStartDate + "T00:00:00");
            let finishDate = null;

            if(isOneDose){
                finishDate = startDate;
            }
            else if (!isCurrent && inpatientEndDate) {
                finishDate = new Date(inpatientEndDate + "T23:59:59");
            }

            const treatmentData = {
                treatment_inpatient: drug.name,
                "treatment-route": route,
                "treatment-frecuency": frecuency,
                "treatment-dose": dose_amount,
                "treatment-unit": dose_unit,
                // treatment-start is a calendar date: store the bare "YYYY-MM-DD" the
                // user picked, NOT a Date object. A Date serializes to an ISO-with-Z
                // instant ("...T00:00:00.000Z") whose UTC day drifts from the picked day
                // in non-GMT timezones, and which the backend's applicable-day check could
                // not parse (SHER-260). Storing the bare string removes the timezone
                // distortion at the source. (treatment-finish intentionally keeps its
                // end-of-day instant — isTreatmentActive relies on the time component.)
                "treatment-start": inpatientStartDate,
                "treatment-finish": finishDate,
                "drug-code": drug.id,
                "treatment-startTime": startTime,
            };

            // Preserve database fields when editing
            if (props.editingElement) {
                if (props.editingElement.submission_id) {
                    treatmentData.submission_id = props.editingElement.submission_id;
                }
                if (props.editingElement.createdAt) {
                    treatmentData.createdAt = props.editingElement.createdAt;
                }
                if (props.editingElement.uuidResearcher) {
                    treatmentData.uuidResearcher = props.editingElement.uuidResearcher;
                }
                if (props.editingElement["treatment-stoppedAt"]) {
                    treatmentData["treatment-stoppedAt"] = props.editingElement["treatment-stoppedAt"];
                }
                if (props.editingElement["treatment-stop_motive"]) {
                    treatmentData["treatment-stop_motive"] = props.editingElement["treatment-stop_motive"];
                }
            } else {
                // For new treatments, add current researcher's UUID
                treatmentData.uuidResearcher = getCurrentResearcherUuid();
            }

            // Handle editing vs creating
            if (props.editingIndex !== null && props.editingIndex !== undefined) {
                // Editing mode - use elementSelected to update state AND close the form
                props.elementSelected(treatmentData);
                if (props.onUpdateDatabase) {
                    props.onUpdateDatabase(treatmentData).catch((error) => {
                        console.error("Error updating treatment:", error);
                    });
                }
            } else if (props.onSaveToDatabase) {
                // Creating new - use onSaveToDatabase
                props.onSaveToDatabase(treatmentData);
            } else {
                // Fallback to elementSelected
                props.elementSelected(treatmentData);
            }

            return;
        }
        if(!isCurrent && (amount === null || !timeUnit)){
            setErrorDuration(true);
            valid = false;
        }
        if(valid){
            const startDate = new Date();
            let finishDate = null;
            if(!isCurrent){
                const unitMinutes = timeUnit === DAYS ? 1440 : timeUnit === WEEKS ? 10080 : timeUnit === MONTHS ? 43200 : null;
                const duration = amount * unitMinutes;
                finishDate = addMinutes(startDate, duration);
            }
            
            const key = props.type === "treatment" ? "treatment" : "treatment_prescription";
            const elementSelected = {
                "drug-code" : drug.id, 
                "treatment-frecuency": frecuency, 
                "treatment-dose": dose, 
                "treatment-start" : startDate, 
                "treatment-finish" : finishDate, 
            };
            elementSelected[key] = drug.name,
             props.elementSelected(elementSelected);
        }
    }
    function drugSelected(drug){
        console.log("Treatment Drug:", drug);
        setErrorDrug(false);
        setDrug(drug);
    }
    function cancel(){
        props.cancel()
    }
    function frecuencySelected(frecuency){
        setfrecuency(frecuency);
        setErrorfrecuency(false);
    }
    function doseSelected(dose){
        setDose(dose);
        setErrorDose(false);
    }
    function routeSelected(route){
        setRoute(route);
        setErrorRoute(false);
    }
    function onChangeIsCurrent(e){
        setIsCurrent(e.target.checked);
        if (e.target.checked) {
            setIsOneDose(false);
            setInpatientEndDate("");
            setErrorEndDate(false);
        }
    }
    function drugError(error){
        setError(error);
    }
    function onChangeIsOnce(e){
        setIsOneDose(e.target.checked);
        if (e.target.checked) {
            setIsCurrent(false);
            setInpatientEndDate("");
            setErrorEndDate(false);
            setfrecuency("single-dose");
            setAmount(0);
            setTimeUnit("days");
        }
    }
    if(error){
        return(
            <Alert severity="error">
                <Translate id="investigation.share.error.description" />
            </Alert>);
    }

    const slaves = props.slaves || [];
    const selectfrecuency = slaves.find(slave => slave.name.includes("frecuency"));


    const selectDoseAmount = slaves.find(slave => slave.name === "treatment-dose");
    const selectDoseUnit = slaves.find(slave => slave.name === "treatment-unit");
    const selectDose = slaves.find(slave => slave.name.includes("dose") && !slave.name.includes("dose_amount") && !slave.name.includes("dose_unit")); // For non-inpatient types
    const isCurrentLabel = props.translate("hospital.chronic");
    const isOneDoseLabel = props.translate("hospital.single-dose");
    const numberElements = [1,2,3,4,5,6,7,8,9,10].map(val => <MenuItem value={val}>{val}</MenuItem>);
    const timesArray = [DAYS, WEEKS, MONTHS].map(val => <MenuItem value={val}><Translate id={`hospital.time-unit-options.${val}`} /></MenuItem>);
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Grid item xs={12} sm={10} lg={3}>
                    <DrugSelector drugSelected={(drug) => drugSelected(drug) } 
                        country={props.country}
                        error={errorDrug} variant={props.variant} type="treatment"
                        freeSolo
                        callbackError={(error) => drugError(error)}
                        initialValue={drug}/>
                </Grid>
            </Grid>
            {props.type === "treatment_inpatient" ? (
                <>
                    <Grid item xs={12}>
                        <Grid item xs={12} sm={4} lg={3}>
                        <TextField
                            id="dose_amount"
                            fullWidth
                            label={props.translate("hospital.treatment-dose")}
                            variant="outlined"
                            type="text"
                            value={dose_amount || ""}
                            onChange={(e) => {
                                const value = e.target.value;
                                
                                if (value === "") {
                                    setDoseAmount(null);
                                    setErrorDoseAmount(false);
                                    return;
                                }
                                
                                
                                // Allow digits, comma, period, and forward slash for fractions
                                const numericPattern = /^\d*[.,/]?\d*$/;
                                
                                if (!numericPattern.test(value)) {
                                    return; // Don't update if pattern doesn't match
                                }
                                
                                // Validate numeric value
                                let numericValue;
                                
                                if (value.includes('/')) {
                                    // Handle fraction
                                    const parts = value.split('/');
                                    if (parts.length !== 2) {
                                        return; // Invalid fraction format
                                    }
                                    const [numerator, denominator] = parts.map(s => s.trim());
                                    const num = parseFloat(numerator);


                                    if (denominator === "") {
                                        // Still typing, allow it
                                        setDoseAmount(value);
                                        setErrorDoseAmount(false);
                                        return;
                                    }

                                    const den = parseFloat(denominator);
                                    
                                    if (isNaN(num) || isNaN(den) || den === 0) {
                                        return; // Invalid fraction
                                    }
                                    
                                    numericValue = num / den;
                                } else {
                                    // Handle integer or decimal (normalize comma to period)
                                    const normalizedValue = value.replace(',', '.');
                                    numericValue = parseFloat(normalizedValue);
                                }
                                
                                // Validate: must be a valid number >= 0
                                if (!isNaN(numericValue) && !isNaN(parseFloat(String(numericValue))) && numericValue >= 0 && isFinite(numericValue)) {
                                    // Store the value as-is (with comma if user typed it, or fraction)
                                    setDoseAmount(value);
                                    setErrorDoseAmount(false);
                                }
                            }}
                            error={errorDoseAmount}                     //Visual error state
                        />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item xs={12} sm={4} lg={3}>
                            <Autocomplete
                                id="dose_unit"
                                fullWidth
                                options={selectDoseUnit?.options || []}
                                getOptionLabel={(option) => props.translate(option.label)}
                                value={selectDoseUnit?.options?.find(opt => opt.value === dose_unit) || null}
                                onChange={(event, value) => {
                                    if(value){
                                        setDoseUnit(value.value);
                                        setErrorDoseUnit(false);
                                    } else {
                                        setDoseUnit(null);
                                    }
                                }}
                                renderInput={(params) => <TextField {...params} 
                                    label={props.translate("hospital.treatment-unit")} variant="outlined" 
                                    error={errorDoseUnit} />}
                            />
                        </Grid>
                    </Grid>
                </>
            ) : (
                <Grid item xs={12}>
                    <Grid item xs={12} sm={4} lg={3}>
                        <Autocomplete
                            id="dose"
                            fullWidth
                            freeSolo
                            options={selectDose?.options || []}
                            value={dose ?? null}
                            inputValue={dose ?? ""}
                            onInputChange={(event, value) => doseSelected(value || null)}
                            getOptionLabel={(option) => typeof option === "string" ? option : props.translate(option.label)}
                            onChange={(event, value) => {
                                const next = value != null ? (typeof value === "string" ? value : value.value) : null;
                                doseSelected(next);
                            }}
                            renderInput={(params) => <TextField {...params} 
                                label={props.translate("hospital.dose")} variant="outlined" 
                                error={errorDose} />}
                        />
                    </Grid>
                </Grid>
            )}

            {
                props.type === "treatment_inpatient" &&
                <Grid item xs={12}>
                    <Grid item xs={12} sm={4} lg={3}>
                        <Autocomplete
                            id="route"
                            fullWidth
                            options={(() => {
                                const routeOptions = slaves.find(slave => slave.name.includes("route"))?.options || [];
                                return [...routeOptions].sort((a, b) => {
                                    const idA = a.id ?? 0;
                                    const idB = b.id ?? 0;
                                    return idA - idB;
                                });
                            })()}
                            getOptionLabel={(option) => props.translate(option.label)}
                            value={(() => {
                                const routeOptions = slaves.find(slave => slave.name.includes("route"))?.options || [];
                                return routeOptions.find(opt => opt.value === route) || null;
                            })()}
                            onChange={(event, value, reason, details) => {
                                if(value){
                                    setRoute(value.value);
                                    setErrorRoute(false);
                                }
                                else{
                                    setRoute(null);
                                }
                            }}
                            renderInput={(params) => <TextField {...params} 
                                label="Route" 
                                variant="outlined" 
                                error={errorRoute} />}
                            />
                    </Grid>
                </Grid>  
            }
            
            {
                ["treatment", "treatment_prescription"].includes(props.type) &&
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox checked={isOneDose} onChange={onChangeIsOnce} />}
                        label={isOneDoseLabel}
                    />
                </Grid>
            }
           <Grid item xs={12}>
                <Grid item xs={12} sm={4} lg={3}>
                    <Autocomplete
                        id="frecuency" disabled={isOneDose}
                        options={selectfrecuency?.options || []}
                        getOptionLabel={(option) => props.translate(option.label)}
                        groupBy={(option) => isHourBasedFrequency(option.value)
                            ? props.translate("hospital.frecuency-group-hour-based")
                            : props.translate("hospital.frecuency-group-standard")
                        }
                        value={selectfrecuency?.options?.find(opt => opt.value === frecuency) || null}
                        onChange={(event, value, reason, details) => {
                            if(value){
                                frecuencySelected(value.value);
                            }
                            else{
                                frecuencySelected(null);
                            }
                        }}
                        renderInput={(params) => <TextField {...params}
                            label={props.translate("hospital.frecuency")} variant="outlined"
                            error={errorfrecuency} />}
                        />
                </Grid>
                {
                    frecuency && isHourBasedFrequency(frecuency) &&
                    <Grid item xs={12} sm={3} lg={2}>
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel>{props.translate("hospital.treatment-startTime-label")}</InputLabel>
                            <Select
                                value={startTime}
                                onChange={(e) => setStartTime(e.target.value)}
                                label={props.translate("hospital.treatment-startTime-label")}
                            >
                                {Array.from({ length: 24 }, (_, i) => {
                                    const hour = String(i).padStart(2, '0');
                                    return <MenuItem key={hour} value={hour}>{hour}:00</MenuItem>;
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                }
            </Grid>
            {
                props.type === "treatment_inpatient" &&
                <React.Fragment>
                    <Grid item xs={12}>
                        <FormControlLabel disabled={isOneDose}
                            control={<Checkbox checked={isCurrent} onChange={onChangeIsCurrent} />}
                            label={isCurrentLabel}
                        />
                    </Grid>
                    <Grid item xs={12} container spacing={2}>
                        <Grid item xs={12} sm={4} lg={3}>
                            <TextField
                                id="inpatient-start-date"
                                label={props.translate("hospital.start-date")}
                                type="date"
                                fullWidth
                                variant="outlined"
                                value={inpatientStartDate}
                                onChange={(e) => setInpatientStartDate(e.target.value)}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} lg={3}>
                            <TextField
                                id="inpatient-end-date"
                                label={props.translate("hospital.end-date")}
                                type="date"
                                fullWidth
                                variant="outlined"
                                disabled={isOneDose || isCurrent}
                                value={inpatientEndDate}
                                onChange={(e) => {
                                    setInpatientEndDate(e.target.value);
                                    setErrorEndDate(false);
                                }}
                                error={errorEndDate}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ min: inpatientStartDate }}
                            />
                        </Grid>
                    </Grid>
                </React.Fragment>
            }
            {
                 ["treatment", "treatment_prescription"].includes(props.type) &&
                <React.Fragment>
                    <Grid item xs={12}>
                        <FormControlLabel disabled={isOneDose}
                            control={<Checkbox checked={isCurrent} onChange={onChangeIsCurrent} />}
                            label={isCurrentLabel}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel id="duration"><Translate id="hospital.duration" /></InputLabel>
                        <FormControl disabled={isOneDose || isCurrent} style={{minWidth: 140}} mt={3} variant="outlined" margin={props.typeMargin} error={errorDuration} >
                            <InputLabel id="numberElements-label"><Translate id="hospital.number-elements" /></InputLabel>
                            <Select
                                id="numberElements"
                                labelId="numberElements-label"
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                >
                                { numberElements }
                            </Select>
                        </FormControl>
                        <FormControl disabled={isOneDose || isCurrent} style={{minWidth: 150}}
                            mt={3} variant="outlined"
                            margin={props.typeMargin} error={errorDuration} >
                            <InputLabel id="timeUnit-label" >
                                <Translate id="hospital.time-unit" />
                            </InputLabel>
                            <Select
                                id="timeUnit"
                                labelId="timeUnit-label"
                                value={timeUnit}
                                onChange={(e) => setTimeUnit(e.target.value)}
                                >
                                { timesArray }
                            </Select>
                        </FormControl>
                    </Grid>
                </React.Fragment>
            }
            <Grid container item xs={12} spacing={1}>
                <Grid item>
                    <ButtonOk onClick={saveDrug}>
                        {props.editingIndex !== null && props.editingIndex !== undefined 
                            ? <Translate id="general.update" /> 
                            : <Translate id="general.add" />}
                    </ButtonOk>
                </Grid>
                <Grid item>
                    <ButtonCancel onClick={cancel} ><Translate id="general.cancel" /></ButtonCancel>    
                </Grid>
            </Grid>
        </Grid>
        
        
    )
}
export default withLocalize(SingleTreatmentSelector);